import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Component, ViewEncapsulation, ElementRef, Inject } from '@angular/core';
import { DialogFullScreenComponentContent } from '@toro/common/shared/models/dialogs/dialog-full-screen';

@Component({
  selector: 'dialog-success-buy',
  templateUrl: './dialog-success-buy.component.html',
  encapsulation: ViewEncapsulation.None
})
export class DialogSuccessBuyComponent extends DialogFullScreenComponentContent {

  constructor(private dialogReference : MatDialogRef<DialogSuccessBuyComponent>, element : ElementRef, @Inject(MAT_DIALOG_DATA) public data : any) {
      super(element);
  }

  dispose(){
    super.close(this.dialogReference, null);
  }
}